










import { Component, Vue, Prop } from 'vue-property-decorator';

import { IBusinessType } from '@/models/business';

@Component({
  components: {}
})
export default class RewardsDisclaimer extends Vue {
  @Prop() type!: IBusinessType;

  get businessInfo() {
    return this.$store.getters['business/getBusinessInfo'].business || {};
  }

  get refund() {
    if (this.businessInfo.refundsLimitDays === 0) return false;

    return `${this.businessInfo.refundsLimitDays} days`;
  }

  get rewardPercentage() {
    return `${+this.businessInfo.coinRewardPercentage}%`;
  }

  get rewardsTitle() {
    const types = {
      [IBusinessType.ONLINE]: 'Online',
      [IBusinessType.INSTORE]: 'In-Store',
      [IBusinessType.BOTH]: 'Online & In-Store'
    };
    return types[this.type];
  }
}
